/**
 * Detalle de una sede (T086 · US7). El sufijo `_` la convierte en ruta hermana de `/sedes`:
 * `_app/sedes.tsx` no renderiza `<Outlet/>` (misma precaución que `empresas_.$companyId.tsx`).
 */
import { createFileRoute } from '@tanstack/react-router';

import { SiteDetailPage } from '../../features/sites/site-detail-page';

export const Route = createFileRoute('/_app/sedes_/$siteId')({
  component: function SiteDetailRoute() {
    const { siteId } = Route.useParams();
    return <SiteDetailPage siteId={siteId} />;
  },
});
